/**
 * Centralized hub data source resolution.
 *
 * `REACT_APP_PAYLOAD_SOURCES` is a comma-separated list of hub module names
 * that should read from Payload CMS
 * (e.g. `promotions,entertainment,navbar,carousels,past-events,high-hand`).
 * Any module not listed falls back to the legacy source (ERS hubs / static navbar / locale JSON).
 *
 * Supported module names include:
 * - `promotions`, `entertainment`, `egd`, `navbar`, `past-events`, `high-hand`
 * - `carousel` — home (`home-carousel`), poker (`poker-carousel`), and EGD (`egd-carousel`)
 * - `high-hand` — High Hand promotion pages (`high-hand-promotions`); Live Preview uses forceEnabled
 */

const PAYLOAD_SOURCES = new Set(
  (process.env.REACT_APP_PAYLOAD_SOURCES ?? "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean),
);

/**
 * @param {string} moduleName - e.g. `promotions`, `egd`, `entertainment`, `navbar`, `carousels`
 * @returns {'ers' | 'payload'}
 */
export function getHubSource(moduleName) {
  const name = String(moduleName).toLowerCase();
  if (PAYLOAD_SOURCES.has(name)) return "payload";
  return "ers";
}

/**
 * @param {string} moduleName - e.g. `promotions`, `egd`, `entertainment`, `navbar`, `carousels`
 * @returns {boolean}
 */
export function isPayloadSource(moduleName) {
  return getHubSource(moduleName) === "payload";
}
